module.exports = __webpack_public_path__ + "media/src/images/icons/gray-close-26a7421fb1548e741495f7e019e84dab.svg";